import * as actionTypes from './../Global_action.types';
import * as api from './../global_api_services/Download.api';


export const downloadAllSelectedIDsRequest = () => ({
  type: actionTypes.DOWNLOAD_SELECTED_REQUEST,
});

export const downloadAllSelectedIDsSuccess = (clients) => ({
  type: actionTypes.DOWNLOAD_SELECTED_SUCCESS,
  payload: clients,
});

export const downloadAllSelectedIDsFailure = (error) => ({
  type: actionTypes.DOWNLOAD_SELECTED_FAILURE,
  payload: error,
});

export const downloadAllSelectedIDsRecords = (data) => {
  return async (dispatch) => {
    dispatch(downloadAllSelectedIDsRequest());
    try {
      const response = await api.downloadAllSelectedIDs(data);
      dispatch(downloadAllSelectedIDsSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(downloadAllSelectedIDsFailure(error));
      return { success: false, message: error };
    }
  };
};

export const globalDownloadAllSelectedIDsRecords = (data) => {
  return async (dispatch) => {
    dispatch(downloadAllSelectedIDsRequest());
    try {
      const response = await api.globalDownloadAllSelectedIDs(data);
      dispatch(downloadAllSelectedIDsSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(downloadAllSelectedIDsFailure(error));
      return { success: false, message: error };
    }
  };
};
